import React from "react";
import { DeviceActivitySummaryTemplate } from "themes/administration/analytics/components";

function DeviceActivitySummary(props) {
    return <DeviceActivitySummaryTemplate {...props} />;
}

export default DeviceActivitySummary;
